// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "104180a-dirty",
    "hash": "104180a",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "104180a-dirty",
    "semverString": null,
    "version": "1.0.0"
};
/* tslint:enable */
